import PersonHistoricNames from "~Features/Person/PersonHistoricNames";

export const MiscTab = ({ data, personId }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: 10,
        flexDirection: "column",
      }}
    >
      <PersonHistoricNames data={data} personId={personId} />
    </div>
  );
};
